import { Box, Card, CardMedia } from '@mui/material';
import { Flight } from '@mui/icons-material';

interface DroneImageProps {
  imageUrl: string | null;
  droneName: string;
  /** Pixels. The panel's 200 by default; the gallery's thumbnails are smaller. */
  height?: number;
}

/**
 * A drone's photo, or the generic placeholder when it has none (G4). Until
 * images arrive (#408) every drone has none, so the placeholder says so to a
 * screen reader rather than being an unlabelled icon.
 */
export const DroneImage: React.FC<DroneImageProps> = ({
  imageUrl,
  droneName,
  height = 200,
}) => {
  const fallbackIcon = (
    <Box
      role="img"
      aria-label={`No photo of ${droneName}`}
      sx={{
        width: '100%',
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'action.hover',
        borderRadius: 1,
        flexShrink: 0,
      }}
    >
      <Flight sx={{ fontSize: Math.round(height * 0.4), color: 'action.active' }} />
    </Box>
  );

  if (!imageUrl) {
    return fallbackIcon;
  }

  return (
    <Card sx={{ borderRadius: 1 }}>
      <CardMedia
        component="img"
        height={height}
        image={imageUrl}
        alt={droneName}
        onError={(e) => {
          // Replace with fallback on error
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
        }}
        sx={{ objectFit: 'cover' }}
      />
    </Card>
  );
};
